import { noop, over } from 'lodash-es';
import React, { useState } from 'react';
import ResetPasswordRequestCard, {
  ResetPasswordRequestCardProps,
} from '../ResetPasswordRequestCard/ResetPasswordRequestCard';
import ResetPasswordSuccessCard from '../ResetPasswordSuccessCard/ResetPasswordSuccessCard';

export interface ResetPasswordCardProps
  extends Pick<ResetPasswordRequestCardProps, 'onSubmit' | 'onSuccess'> {}

/**
 * A card that prompts a user to reset their password.
 * Once the request is fulfilled, a "success" card is shown with a button that allows the user
 * to redirect to the login page or to the login modal on applications using the auth modal.
 *
 */
export const ResetPasswordCard: React.FC<ResetPasswordCardProps> = ({
  onSubmit,
  onSuccess = noop,
}) => {
  const [isRequestSuccessful, setIsRequestSuccessful] = useState(false);
  const handleSuccess = () => {
    setIsRequestSuccessful(true);
  };

  if (!isRequestSuccessful) {
    return (
      <ResetPasswordRequestCard
        onSubmit={onSubmit}
        onSuccess={over([handleSuccess, onSuccess])}
      />
    );
  }

  return <ResetPasswordSuccessCard />;
};

export default ResetPasswordCard;
